/* eslint-disable no-restricted-imports */
import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  RadioGroup,
  Radio,
  MenuItem,
  Select,
  FormControlLabel
} from "@material-ui/core";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Spinner } from "react-bootstrap";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import { v4 as uuidv4 } from "uuid";
import {
  getAllUCConfig,
  saveUCConfig,
  downloadBackup
} from "../modules/Auth/_redux/adminCrud";

export function BackupPage() {
  const useStyles = makeStyles(theme => ({
    labelStyle: {
      display: "inline-block",
      marginTop: "-2px",
      fontSize: "1.2rem",
      width: "120px"
    },
    inputStyle: {
      display: "inline-flex",
      width: "200px",
      height: "32px",
      border: "1px solid #c8cace",
      paddingLeft: "8px",
      borderRadius: "4px 4px 4px 4px",
      ":active": {
        border: "1px solid #c8cace"
      }
    },
    selectStyle: {
      display: "inline-flex",
      width: "200px",
      height: "32px",
      border: "1px solid #c8cace",
      paddingLeft: "8px",
      background: "transparent",
      marginRight: "12px",
      borderRadius: "4px 4px 4px 4px",
      ":active": {
        background: "transparent"
      }
    },
    buttonStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1.2rem",
      marginRight: "12px"
    },
    buttonSmallStyle: {
      width: "60px",
      height: "28px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1rem"
      //   marginLeft: "12px"
    },

    buttonDisableStyle: {
      color: "#b4b5b8",
      border: "1px solid #b4b5b8",
      background: "#ebedf1"
    },
    buttonClearStyle: {
      width: "32px",
      height: "32px",
      border: "0px solid #123456",
      marginRight: "12px",
      "&:hover": {
        backgroundColor: "transparent !important"
      }
    },
    searchStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1rem",
      float: "right"
    },
    dateStyle: {
      width: "160px",
      height: "32px",
      color: "#123456",
      border: "1px solid #c8cace",
      fontSize: "1rem",
      marginRight: "36px",
      textAlign: "left",
      background: "transparent",
      borderRadius: "4px 4px 4px 4px",
      paddingLeft: "12px"
    },

    boxContainer: {
      display: "inline-block",
      width: "100%",
      verticalAlign: "top"
    },
    box30Style: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid lightgray",
      padding: "24px",
      marginBottom: "12px"
    },
    boxStyle: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid lightgray",
      padding: "24px",
      marginBottom: "12px"
    },
    subTitleStyle: {
      display: "block",
      fontSize: "1.2rem",
      width: "100%",
      marginBottom: "12px",
      fontWeight: "bold",
      alignItems: "baseline",
      color: "#555555"
    },
    subTitleLastStyle: {
      fontSize: "1rem",
      //   fontWeight: "bold",
      color: "#555555",
      marginTop: "-8px"
    },
    headerRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px"
    },
    headerColStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "50%",
      background: "#dfe2e8",
      height: "44px"
    },
    headerCol100Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "100%",
      background: "#dfe2e8",
      height: "44px"
    },
    headerCheckboxStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "44px",
      background: "#dfe2e8",
      height: "44px"
    },
    dataCheckboxStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "44px",
      //   background: "#dfe2e8",
      height: "44px"
    },
    dataRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px",
      borderBottom: "1px solid lightgray"
    },
    width100Style: {
      width: "100%"
    },
    dataColStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "50%",
      height: "44px"
    },
    dataCol100Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "100%",
      height: "44px"
    },
    dataColSmallStyle: {
      display: "inline-block",
      fontSize: "12px",
      textAlign: "center",
      width: "50%",
      height: "44px",
      overflow: "hidden",
      lineHeight: "16px",
      paddingTop: "6px"
    },
    dataColTextStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "left",
      //   width: "50%",
      height: "44px"
    },
    radioStyle: {
      width: "80px",
      fontSize: "1rem",
      //   background: "transparent",
      color: "#555555",
      borderColor: "#dfe2e8",
      //   paddingTop: "6px",
      //   "&:hover": {
      //     color: "#123456",
      //     backgroundColor: "#eae4f5 !important"
      //   },
      "&:active": {
        color: "white",
        backgroundColor: "#123456 !important"
      }
    },
    selected: {
      color: "white",
      backgroundColor: "#123456 !important"
    }
  }));

  const [loading, setLoading] = useState(false);

  const [backupTimeList, setBackupTimeList] = useState([
    {
      date: "TUE",
      hour: "04",
      minute: "40"
    }
  ]);

  const Styles = useStyles();
  const [refresh, setRefresh] = React.useState(false);

  const [backupHistoryDeal, setBackupHistoryDeal] = React.useState("SAVE");

  const [ucBackupPolicy, setUcBackupPolicy] = React.useState("AUTO");
  const [ucBackupTargetDomain, setUcBackupTargetDomain] = React.useState(
    "TRUE"
  );
  const [ucBackupTargetConfig, setUcBackupTargetConfig] = React.useState(
    "FALSE"
  );
  const [ucBackupTargetStat, setUcBackupTargetStat] = React.useState("TRUE");
  const [ucBackupTargetLogger, setUcBackupTargetLogger] = React.useState(
    "FALSE"
  );
  const [ucBackupLocation, setUcBackupLocation] = React.useState("SFTP"); // SFTP | PATH
  const [ucBackupServerIp, setUcBackupServerIp] = React.useState(
    "192.168.10.127"
  );
  const [ucBackupServerPort, setUcBackupServerPort] = React.useState("22");
  const [ucBackupId, setUcBackupId] = React.useState("mailbackup");
  const [ucBackupPassword, setUcBackupPassword] = React.useState("pwd#1234");
  const [ucBackupPath, setUcBackupPath] = React.useState(
    "/home/mailbackup/bk"
  );

  const [ucBackupStaticPath, setUcBackupStaticPath] = React.useState(
    "/home/mailbackup/bk"
  );
  const [ucBackupHistoryCount, setUcBackupHistoryCount] = React.useState(10);
  const [ucBackupDate, setUcBackupDate] = React.useState("WED");
  const [ucBackupHour, setUcBackupHour] = React.useState("04");
  const [ucBackupMinute, setUcBackupMinute] = React.useState("20");

  const [showAsk, setShowAsk] = React.useState(false);
  const [showNew, setShowNew] = React.useState(false);
  const [showToast, setShowToast] = React.useState(false);

  const checkIpAddress = () => {
    return true;
  };

  const handleChangeBackupFileCount = event => {
    setUcBackupHistoryCount(event.target.value);
  };

  const handleChangeBackupPolicy = event => {
    setUcBackupPolicy(event.target.value);
  };

  const handleChangeBackupLocation = event => {
    setUcBackupLocation(event.target.value);
  };

  const handleChangeDate = (event, index) => {
    // backupTimeList[index].date = event.target.value;
    setUcBackupDate(event.target.value);
    setRefresh(!refresh);
  };

  const handleChangeHour = (event, index) => {
    // backupTimeList[index].hour = event.target.value;
    setUcBackupHour(event.target.value);
    setRefresh(!refresh);
  };

  const handleChangeMinute = (event, index) => {
    // backupTimeList[index].minute = event.target.value;
    setUcBackupMinute(event.target.value);
    setRefresh(!refresh);
  };

  const handlePressDelete = index => {
    backupTimeList.splice(index, 1);
    setRefresh(!refresh);
  };

  const handleChangeBackupDeal = event => {
    setBackupHistoryDeal(event.target.value);
    setRefresh(!refresh);
  };

  const handlePressBackupDownload = () => {
    const types = [];
    if (ucBackupTargetDomain === "TRUE") types.push("domain");
    if (ucBackupTargetConfig === "TRUE") types.push("conf");
    if (ucBackupTargetStat === "TRUE") types.push("zmstat");
    if (ucBackupTargetLogger === "TRUE") types.push("logger");

    console.log("downloadBackup.Types", types.join(","));

    setLoading(true);
    downloadBackup(types.join(",")).then(result => {
      const downloadUrl = result.data.downloadUrl;

      console.log("downloadBackup", downloadUrl);
      const link = document.createElement("a");
      link.href = downloadUrl;
      // link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setLoading(false);

      toast(
        "서버에서 준비되면 다운로드가 시작됩니다. 페이지를 이동하지 마십시요."
      );
    })
    .catch(error => {
      console.log(error)
    })
  };

  const initConfig = () => {
    getAllUCConfig().then(result => {
      console.log("getAllUCConfig", result.data.ucConfig);
      const config = result.data.ucConfig;

      setUcBackupDate(config.ucBackupDate);
      setUcBackupHistoryCount(config.ucBackupHistoryCount);
      setUcBackupHour(config.ucBackupHour);
      setUcBackupId(config.ucBackupId);
      setUcBackupLocation(config.ucBackupLocation);
      setUcBackupMinute(config.ucBackupMinute);
      setUcBackupPassword(config.ucBackupPassword);
      setUcBackupPath(config.ucBackupPath);
      setUcBackupPolicy(config.ucBackupPolicy);
      setUcBackupServerIp(config.ucBackupServerIp);
      setUcBackupServerPort(config.ucBackupServerPort);
      setUcBackupStaticPath(config.ucBackupStaticPath);
      setUcBackupTargetConfig(config.ucBackupTargetConfig);
      setUcBackupTargetDomain(config.ucBackupTargetDomain);
      setUcBackupTargetStat(config.ucBackupTargetStat);
      setUcBackupTargetLogger(config.ucBackupTargetLogger);
    })
    .catch(error => {
      console.log(error)
    })
  };

  const handlePressSaveConfig = () => {
    let params = {
      ucBackupPolicy,
      ucBackupTargetConfig,
      ucBackupTargetDomain,
      ucBackupTargetStat,
      ucBackupTargetLogger,
      ucBackupLocation,
      ucBackupDate,
      ucBackupHour,
      ucBackupMinute,
      ucBackupHistoryCount
    };

    if (ucBackupPolicy === "MANUAL")
      params = {
        ucBackupPolicy,
        ucBackupTargetConfig,
        ucBackupTargetDomain,
        ucBackupTargetStat,
        ucBackupTargetLogger
      };
    else {
      if (ucBackupLocation === "SFTP") {
        params.ucBackupServerIp = ucBackupServerIp;
        params.ucBackupServerPort = ucBackupServerPort;
        params.ucBackupId = ucBackupId;
        params.ucBackupPassword = ucBackupPassword;
        params.ucBackupPath = ucBackupPath;
      } else {
        params.ucBackupStaticPath = ucBackupStaticPath;
      }
    }

    console.log("PARAMS", params);

    saveUCConfig(params).then(result => {
      console.log("saveUCConfig", result);
    })
    .catch(error => {
      console.log(error)
    })
  };

  useEffect(() => {
    initConfig();
  }, []);

  useEffect(() => {}, [refresh]);

  return (
    <>
      <ToastContainer />
      {loading ? (
        <div style={{ width: "100%", height: "100%" }}>
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            style={{ margin: "40% 50% 30% 50%", width: "24px", height: "24px" }}
          />
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        <div>
          <div
            style={{
              marginTop: "12px",
              marginLeft: "-12px",
              height: "100%"
            }}
          >
            {/* -------------------- */}

            <div className={Styles.boxContainer}>
              <div className={Styles.boxStyle}>
                <div className={Styles.subTitleStyle}>
                  <Button
                    className={Styles.buttonStyle}
                    onClick={() => {
                      handlePressSaveConfig();
                    }}
                  >
                    저장
                  </Button>
                </div>

                <div className={Styles.subTitleLastStyle}>
                  <div className={Styles.labelStyle}>백업정책</div>
                  <RadioGroup
                    aria-label="방향"
                    name="gender1"
                    style={{
                      display: "inline-block",
                      fontSize: "1.2rem"
                    }}
                    value={ucBackupPolicy}
                    onChange={handleChangeBackupPolicy}
                  >
                    <FormControlLabel
                      value="MANUAL"
                      style={{
                        marginTop: "4px",
                        marginRight: "12px",
                        fontSize: "1.2rem"
                      }}
                      control={<Radio />}
                      label="수동백업"
                    />
                    <Button
                      style={{ width: "80px", marginRight: "24px" }}
                      className={Styles.buttonSmallStyle}
                      onClick={() => handlePressBackupDownload()}
                    >
                      PC에 저장
                    </Button>

                    <FormControlLabel
                      value="AUTO"
                      style={{ marginTop: "4px", fontSize: "1.2rem" }}
                      control={<Radio />}
                      label="자동백업"
                    />
                  </RadioGroup>
                </div>

                <div className={Styles.subTitleLastStyle}>
                  {/* <InputLabel htmlFor="age-simple">메일백업 / PC에 저장</InputLabel> */}
                  <div className={Styles.labelStyle}>로그레벨</div>

                  <FormControlLabel
                    style={{
                      marginTop: "4px",
                      marginRight: "12px",
                      fontSize: "1.2rem"
                    }}
                    control={<Checkbox />}
                    label="도메인 및 계정정보"
                    checked={ucBackupTargetDomain === "TRUE"}
                    onChange={e => {
                      if (ucBackupTargetDomain === "TRUE")
                        setUcBackupTargetDomain("FALSE");
                      else setUcBackupTargetDomain("TRUE");

                      setRefresh(!refresh);
                    }}
                  />
                  <FormControlLabel
                    style={{ marginTop: "4px", fontSize: "1.2rem" }}
                    control={<Checkbox />}
                    label="환경설정"
                    checked={ucBackupTargetConfig === "TRUE"}
                    onChange={e => {
                      if (ucBackupTargetConfig === "TRUE")
                        setUcBackupTargetConfig("FALSE");
                      else setUcBackupTargetConfig("TRUE");

                      setRefresh(!refresh);
                    }}
                  />
                  <FormControlLabel
                    style={{ marginTop: "4px", fontSize: "1.2rem" }}
                    control={<Checkbox />}
                    label="통계"
                    checked={ucBackupTargetStat === "TRUE"}
                    onChange={e => {
                      if (ucBackupTargetStat === "TRUE")
                        setUcBackupTargetStat("FALSE");
                      else setUcBackupTargetStat("TRUE");

                      setRefresh(!refresh);
                    }}
                  />
                  <FormControlLabel
                    value="LOGS"
                    style={{ marginTop: "4px", fontSize: "1.2rem" }}
                    control={<Checkbox />}
                    label="로그"
                    checked={ucBackupTargetLogger === "TRUE"}
                    onChange={e => {
                      if (ucBackupTargetLogger === "TRUE")
                        setUcBackupTargetLogger("FALSE");
                      else setUcBackupTargetLogger("TRUE");

                      setRefresh(!refresh);
                    }}
                  />
                </div>

                {ucBackupPolicy === "AUTO" && (
                  <>
                    <div className={Styles.subTitleLastStyle}>
                      {/* <InputLabel htmlFor="age-simple">메일백업 / PC에 저장</InputLabel> */}
                      <div className={Styles.labelStyle}>백업방법</div>
                      <RadioGroup
                        aria-label="방향"
                        name="gender1"
                        style={{
                          display: "inline-block",
                          fontSize: "1.2rem"
                        }}
                        value={ucBackupLocation}
                        onChange={handleChangeBackupLocation}
                      >
                        <FormControlLabel
                          value="SFTP"
                          style={{
                            marginTop: "4px",
                            marginRight: "12px",
                            fontSize: "1.2rem"
                          }}
                          control={<Radio />}
                          label="SFTP"
                        />
                        <FormControlLabel
                          value="PATH"
                          style={{ marginTop: "4px", fontSize: "1.2rem" }}
                          control={<Radio />}
                          label="서버의 특정 경로"
                        />
                      </RadioGroup>
                    </div>

                    {ucBackupLocation === "SFTP" && (
                      <>
                        <div
                          className={Styles.subTitleLastStyle}
                          style={{ marginTop: "0px" }}
                        >
                          <div className={Styles.labelStyle}>서버명/IP</div>
                          <input
                            type="text"
                            value={ucBackupServerIp}
                            className={Styles.inputStyle}
                            onChange={e => {
                              setUcBackupServerIp(e.target.value);
                            }}
                          />
                        </div>

                        <div
                          className={Styles.subTitleLastStyle}
                          style={{ marginTop: "6px" }}
                        >
                          <div className={Styles.labelStyle}>포트</div>
                          <input
                            type="text"
                            value={ucBackupServerPort}
                            className={Styles.inputStyle}
                            onChange={e => {
                              setUcBackupServerPort(e.target.value);
                            }}
                          />
                        </div>

                        <div
                          className={Styles.subTitleLastStyle}
                          style={{ marginTop: "6px" }}
                        >
                          <div className={Styles.labelStyle}>사용자 ID</div>
                          <input
                            type="text"
                            value={ucBackupId}
                            className={Styles.inputStyle}
                            onChange={e => {
                              setUcBackupId(e.target.value);
                            }}
                          />
                        </div>
                        <div
                          className={Styles.subTitleLastStyle}
                          style={{ marginTop: "6px" }}
                        >
                          <div className={Styles.labelStyle}>
                            사용자 비밀번호
                          </div>
                          <input
                            type="text"
                            value={ucBackupPassword}
                            className={Styles.inputStyle}
                            onChange={e => {
                              setUcBackupPassword(e.target.value);
                            }}
                          />
                        </div>

                        <div
                          className={Styles.subTitleLastStyle}
                          style={{ marginTop: "6px" }}
                        >
                          <div className={Styles.labelStyle}>저장경로</div>
                          <input
                            type="text"
                            value={ucBackupPath}
                            className={Styles.inputStyle}
                            onChange={e => {
                              setUcBackupPath(e.target.value);
                            }}
                          />
                        </div>
                      </>
                    )}

                    {ucBackupLocation === "PATH" && (
                      <>
                        <div
                          className={Styles.subTitleLastStyle}
                          style={{ marginTop: "6px" }}
                        >
                          <div className={Styles.labelStyle}>저장경로</div>
                          <input
                            type="text"
                            value={ucBackupStaticPath}
                            className={Styles.inputStyle}
                            onChange={e => {
                              setUcBackupStaticPath(e.target.value);
                            }}
                          />
                        </div>

                        <div
                          className={Styles.subTitleLastStyle}
                          style={{ marginTop: "6px" }}
                        >
                          <div className={Styles.labelStyle}>
                            백업파일 보관설정
                          </div>
                          <RadioGroup
                            aria-label="방향"
                            name="gender1"
                            style={{
                              display: "inline-block",
                              fontSize: "1.2rem"
                            }}
                            value={backupHistoryDeal}
                            onChange={handleChangeBackupDeal}
                          >
                            <FormControlLabel
                              value="NOSAVE"
                              style={{ marginTop: "4px", fontSize: "1.2rem" }}
                              control={<Radio />}
                              label="삭제하지 않음"
                            />
                            <FormControlLabel
                              value="SAVE"
                              style={{ marginTop: "4px", fontSize: "1.2rem" }}
                              control={<Radio />}
                              label="최근에 백업한"
                            />
                            {/* <input
                      type="text"
                      value={backFileCount}
                      style={{ width: "40px" }}
                      className={Styles.inputStyle}
                      onChange={e => {
                        console.log("IP", e.target.value);
                        setBackFileCount(e.target.value);
                      }}
                    /> */}

                            <Select
                              value={ucBackupHistoryCount}
                              className={Styles.selectStyle}
                              onChange={handleChangeBackupFileCount}
                              style={{
                                width: "80px"
                              }}
                            >
                              <MenuItem value="--">갯수선택</MenuItem>
                              <MenuItem value="5">5개</MenuItem>
                              <MenuItem value="10">10개</MenuItem>
                              <MenuItem value="50">50개</MenuItem>
                              <MenuItem value="100">100개</MenuItem>
                            </Select>

                            <span style={{ fontSize: "1rem" }}>
                              {" "}
                              개 파일 보관
                            </span>
                          </RadioGroup>
                        </div>
                      </>
                    )}
                    {backupTimeList.map((bkTime, index) => (
                      <div
                        key={uuidv4()}
                        className={Styles.subTitleLastStyle}
                        style={{ marginTop: "6px" }}
                      >
                        <div className={Styles.labelStyle}>백업시간</div>

                        <Select
                          value={ucBackupDate}
                          className={Styles.selectStyle}
                          onChange={e => handleChangeDate(e, index)}
                          style={{
                            width: "80px"
                          }}
                        >
                          <MenuItem value="---">요일선택</MenuItem>
                          <MenuItem value="MON">월요일</MenuItem>
                          <MenuItem value="TUE">화요일</MenuItem>
                          <MenuItem value="WED">수요일</MenuItem>
                          <MenuItem value="THU">목요일</MenuItem>
                          <MenuItem value="FRI">금요일</MenuItem>
                          <MenuItem value="SAT">토요일</MenuItem>
                          <MenuItem value="SUN">일요일</MenuItem>
                        </Select>

                        <Select
                          value={ucBackupHour}
                          className={Styles.selectStyle}
                          onChange={e => handleChangeHour(e, index)}
                          style={{
                            width: "80px"
                          }}
                        >
                          <MenuItem value="--">시간선택</MenuItem>
                          <MenuItem value="00">00시</MenuItem>
                          <MenuItem value="01">01시</MenuItem>
                          <MenuItem value="02">02시</MenuItem>
                          <MenuItem value="03">03시</MenuItem>
                          <MenuItem value="04">04시</MenuItem>
                          <MenuItem value="05">05시</MenuItem>
                          <MenuItem value="06">06시</MenuItem>
                          <MenuItem value="07">07시</MenuItem>
                          <MenuItem value="08">08시</MenuItem>
                          <MenuItem value="09">09시</MenuItem>
                          <MenuItem value="10">10시</MenuItem>
                          <MenuItem value="11">11시</MenuItem>
                          <MenuItem value="12">12시</MenuItem>
                          <MenuItem value="13">13시</MenuItem>
                          <MenuItem value="14">14시</MenuItem>
                          <MenuItem value="15">15시</MenuItem>
                          <MenuItem value="16">16시</MenuItem>
                          <MenuItem value="17">17시</MenuItem>
                          <MenuItem value="18">18시</MenuItem>
                          <MenuItem value="19">19시</MenuItem>
                          <MenuItem value="20">20시</MenuItem>
                          <MenuItem value="21">21시</MenuItem>
                          <MenuItem value="22">22시</MenuItem>
                          <MenuItem value="23">23시</MenuItem>
                        </Select>

                        <Select
                          value={ucBackupMinute}
                          className={Styles.selectStyle}
                          onChange={e => handleChangeMinute(e, index)}
                          style={{
                            width: "80px"
                          }}
                        >
                          <MenuItem value="--">분선택</MenuItem>
                          <MenuItem value="00">00분</MenuItem>
                          <MenuItem value="10">10분</MenuItem>
                          <MenuItem value="20">20분</MenuItem>
                          <MenuItem value="30">30분</MenuItem>
                          <MenuItem value="40">40분</MenuItem>
                          <MenuItem value="50">50분</MenuItem>
                        </Select>
                        {/* <img
                      src={toAbsoluteUrl("/media/images/btn_delete.svg")}
                      alt=""
                      onClick={() => handlePressDelete(index)}
                    /> */}
                      </div>
                    ))}

                    {/* <div
                  className={Styles.subTitleLastStyle}
                  style={{ marginTop: "6px" }}
                >
                  <div className={Styles.labelStyle}> </div>
                  <Button
                    style={{ width: "80px", marginRight: "24px" }}
                    className={Styles.buttonSmallStyle}
                    onClick={() => handlePressNew()}
                  >
                    시간 추가
                  </Button>
                </div> */}
                  </>
                )}
              </div>
            </div>
          </div>

          <Dialog
            open={showAsk}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"삭제"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                선택한 항목을 삭제하시겠습니까?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                color="primary"
                onClick={() => {
                  setShowAsk(false);
                  setShowToast(true);
                }}
              >
                아니오
              </Button>
              <Button
                color="primary"
                autoFocus
                onClick={() => {
                  setShowAsk(false);
                }}
              >
                예
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </>
  );
}
